import { StructuredText, renderNodeRule } from 'react-datocms/structured-text'

import { TextLink } from '@factorialco/deprecated-design-system'
import { isLink, isParagraph } from 'datocms-structured-text-utils'

const StructuredDescription = ({ content }: { content: string }) => {
  const parsedDescription = JSON.parse(content)

  return (
    <StructuredText
      data={parsedDescription}
      customNodeRules={[
        renderNodeRule(isParagraph, ({ key, children }) => {
          return (
            <p
              className="text-f1-foreground"
              style={{ lineHeight: '22px', marginBottom: '8px' }}
              key={key}
            >
              {children}
            </p>
          )
        }),
        renderNodeRule(isLink, ({ node, key, children }) => {
          return (
            <TextLink key={key} target="_blank" to={node.url}>
              {children}
            </TextLink>
          )
        }),
      ]}
    />
  )
}

export default StructuredDescription
